export const SAVE_PAGE_FILTERS = 'SAVE_PAGE_FILTERS';

export enum FiltersPageEnum {
  MODELS = 'modelsPage',
  BOM = 'bomPage',
  BUYERS = 'buyersPage',
}
